/**
 * CocktailBox Header — Navigation, Cart Badge, Cart Notification
 */

(function () {
  'use strict';

  // ===========================================================================
  // NAVIGATION
  // ===========================================================================

  function initNavigation() {
    if (!initNavigation._hasResizeListener) {
      initNavigation._hasResizeListener = true;
      window.addEventListener('resize', debounce(initNavigation, 200));
    }

    var isMobile = window.innerWidth < 992;

    if (isMobile && initNavigation._lastMode !== 'mobile') {
      initMobileMenu();
      initNavigation._lastMode = 'mobile';
    } else if (!isMobile && initNavigation._lastMode !== 'desktop') {
      initDesktopDropdowns();
      initNavigation._lastMode = 'desktop';
    }
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  // ---------------------------------------------------------------------------
  // Mobile menu
  // ---------------------------------------------------------------------------

  function initMobileMenu() {
    var btn = document.querySelector('[data-menu-button]');
    var nav = document.querySelector('[data-menu-status]');
    if (!btn || !nav) return;

    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'mobile-navigation');
    nav.setAttribute('id', 'mobile-navigation');
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Основна навигация');

    function setMobileMenu(open) {
      nav.dataset.menuStatus = open ? 'open' : 'closed';
      btn.setAttribute('aria-expanded', open);

      // Lock/unlock body scroll
      document.body.style.overflow = open ? 'hidden' : '';

      // Toggle menu-open class on nav wrapper (reverts light nav to default)
      var wrapper = document.querySelector('.cb-nav-wrapper');
      if (wrapper) {
        if (open) {
          wrapper.classList.add('cb-nav--menu-open');
        } else {
          wrapper.classList.remove('cb-nav--menu-open');
        }
        updateNavSolid();
      }
    }

    if (!btn._mobileClick) {
      btn._mobileClick = true;
      btn.addEventListener('click', function () {
        setMobileMenu(nav.dataset.menuStatus !== 'open');
      });

      // Esc closes the open mobile menu and returns focus to the toggle
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || nav.dataset.menuStatus !== 'open') return;
        setMobileMenu(false);
        btn.focus();
      });
    }

    var toggles = document.querySelectorAll('.cb-nav-link[aria-haspopup]');
    Array.from(toggles).forEach(function (toggle, i) {
      var dd = toggle.nextElementSibling;
      if (!dd || !dd.classList.contains('cb-nav-dropdown')) return;
      if (toggle._mobileDropdownInit) return;
      toggle._mobileDropdownInit = true;

      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';

        Array.from(toggles).forEach(function (other) {
          if (other !== toggle) {
            other.setAttribute('aria-expanded', 'false');
            var otherDd = other.nextElementSibling;
            if (otherDd) otherDd.setAttribute('aria-hidden', 'true');
          }
        });

        toggle.setAttribute('aria-expanded', !open);
        dd.setAttribute('aria-hidden', open ? 'true' : 'false');
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Desktop dropdowns
  // ---------------------------------------------------------------------------

  function initDesktopDropdowns() {
    var toggles = Array.from(document.querySelectorAll('.cb-nav-link[aria-haspopup]'));
    var plainLinks = Array.from(document.querySelectorAll('.cb-nav-link:not([aria-haspopup])'));

    toggles.forEach(function (toggle, i) {
      var dd = toggle.nextElementSibling;
      if (!dd || !dd.classList.contains('cb-nav-dropdown') || toggle._desktopInit) return;
      toggle._desktopInit = true;

      toggle.setAttribute('aria-expanded', 'false');
      dd.setAttribute('aria-hidden', 'true');

      // Click handler
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAllDropdowns(toggles);
        if (!isOpen) openDropdown(toggle, dd);
      });

      // Hover handlers
      var leaveTimeout;

      toggle.addEventListener('mouseenter', function () {
        var anyOpen = toggles.some(function (x) {
          return x.getAttribute('aria-expanded') === 'true';
        });

        closeAllDropdowns(toggles);

        if (anyOpen) {
          setTimeout(function () { openDropdown(toggle, dd); }, 20);
        } else {
          openDropdown(toggle, dd);
        }
      });

      toggle.addEventListener('mouseleave', function () {
        leaveTimeout = setTimeout(function () {
          if (!dd.matches(':hover')) closeDropdown(toggle, dd);
        }, 100);
      });

      dd.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimeout);
        openDropdown(toggle, dd);
      });

      dd.addEventListener('mouseleave', function () {
        closeDropdown(toggle, dd);
      });

      // Keyboard
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        } else if (e.key === 'Escape') {
          closeDropdown(toggle, dd);
          toggle.focus();
        }
      });

      dd.addEventListener('keydown', function (e) {
        var items = Array.from(dd.querySelectorAll('.cb-nav-dropdown__link'));
        var idx = items.indexOf(document.activeElement);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items[(idx + 1) % items.length].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          items[(idx - 1 + items.length) % items.length].focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closeDropdown(toggle, dd);
          toggle.focus();
        }
      });
    });

    // Close on hover over plain links
    plainLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        closeAllDropdowns(toggles);
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      var inside = toggles.some(function (toggle) {
        var dd = toggle.nextElementSibling;
        return toggle.contains(e.target) || (dd && dd.contains(e.target));
      });
      if (!inside) closeAllDropdowns(toggles);
    });
  }

  function updateNavSolid() {
    var wrapper = document.querySelector('.cb-nav-wrapper');
    if (!wrapper) return;
    var anyOpen = !!document.querySelector('.cb-nav-dropdown[aria-hidden="false"]');
    var menuOpen = wrapper.classList.contains('cb-nav--menu-open');
    if (anyOpen || menuOpen || window._cbNavScrolledPast) {
      wrapper.classList.add('cb-nav--solid');
    } else {
      wrapper.classList.remove('cb-nav--solid');
    }
  }

  function updateDropdownOpen() {
    var wrapper = document.querySelector('.cb-nav-wrapper');
    if (!wrapper) return;
    var anyOpen = !!document.querySelector('.cb-nav-dropdown[aria-hidden="false"]');
    if (anyOpen) {
      wrapper.classList.add('cb-nav--dropdown-open');
    } else {
      wrapper.classList.remove('cb-nav--dropdown-open');
    }
  }

  function openDropdown(toggle, dd) {
    toggle.setAttribute('aria-expanded', 'true');
    dd.setAttribute('aria-hidden', 'false');
    updateNavSolid();
    updateDropdownOpen();
  }

  function closeDropdown(toggle, dd) {
    toggle.setAttribute('aria-expanded', 'false');
    dd.setAttribute('aria-hidden', 'true');
    updateNavSolid();
    updateDropdownOpen();
  }

  function closeAllDropdowns(toggles) {
    toggles.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var d = t.nextElementSibling;
      if (d) d.setAttribute('aria-hidden', 'true');
    });
    updateNavSolid();
    updateDropdownOpen();
  }

  // ===========================================================================
  // CART BADGE
  // ===========================================================================

  var badge = document.getElementById('cb-cart-badge');

  function updateBadge(count) {
    if (!badge) return;
    badge.textContent = count > 99 ? '99+' : count;
    badge.dataset.count = count;
    // The link's accessible name carries the count; the visual badge is hidden from screen readers
    var link = badge.closest('a');
    if (link && link.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel + ' (' + count + ')');
  }

  function fetchCartCount() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        return cart.item_count;
      });
  }

  fetchCartCount().catch(function () {});

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      if (window.location.pathname === '/cart') {
        window.location.reload();
      } else {
        fetchCartCount().catch(function () {});
      }
    }
  });

  document.addEventListener('cb:cart:added', function () {
    setTimeout(function () { fetchCartCount().catch(function () {}); }, 100);
  });

  window.cbCartBadge = { update: updateBadge, refresh: fetchCartCount };

  // ===========================================================================
  // CART NOTIFICATION TOAST
  // ===========================================================================

  var notification = document.getElementById('cb-cart-notification');
  var notificationTitle = document.getElementById('cb-cart-notification-title');
  var closeBtn = document.getElementById('cb-cart-notification-close');
  var hideTimeout = null;

  function showNotification(productName) {
    if (!notification || !notificationTitle) return;
    if (hideTimeout) clearTimeout(hideTimeout);
    notificationTitle.textContent = productName || 'Product';
    notification.classList.add('cb-cart-notification--visible');
    hideTimeout = setTimeout(hideNotification, 4000);
  }

  function hideNotification() {
    if (!notification) return;
    notification.classList.remove('cb-cart-notification--visible');
    if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      hideNotification();
    });
  }

  document.addEventListener('cb:cart:added', function (e) {
    // Skip toast if cart drawer handles the feedback
    if (document.getElementById('cb-cart-drawer')) return;
    var name = e.detail && e.detail.productName ? e.detail.productName : 'Product';
    showNotification(name);
  });

  window.cbCartNotification = { show: showNotification, hide: hideNotification };

  // ===========================================================================
  // CART INTERCEPTOR — detect cart changes from any app (fetch + XHR)
  // ===========================================================================

  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    var method = (options && options.method) ? options.method.toUpperCase() : 'GET';
    var isCartMod = (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/update') !== -1 || urlStr.indexOf('/cart/change') !== -1) && method === 'POST';

    if (isCartMod) {
      return originalFetch.apply(this, arguments).then(function (response) {
        if (response.ok) {
          setTimeout(function () {
            if (window.cbCartBadge) window.cbCartBadge.refresh().catch(function () {});
          }, 300);
        }
        return response;
      });
    }
    return originalFetch.apply(this, arguments);
  };

  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cbMethod = method;
    this._cbUrl = url;
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var url = xhr._cbUrl || '';
    var method = (xhr._cbMethod || '').toUpperCase();
    var isCartMod = (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/change') !== -1) && method === 'POST';

    if (isCartMod) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          setTimeout(function () {
            if (window.cbCartBadge) window.cbCartBadge.refresh().catch(function () {});
          }, 300);
        }
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  // ===========================================================================
  // SCROLL-DIRECTION STICKY NAV
  // ===========================================================================

  function initScrollNav() {
    var header = document.querySelector('.cb-header-section');
    if (!header) return;

    var lastScrollY = window.scrollY;
    var threshold = window.innerHeight;
    var ticking = false;

    window._cbNavScrolledPast = window.scrollY > 50;
    updateNavSolid();

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var currentY = window.scrollY;

        // Solid background when scrolled past top
        window._cbNavScrolledPast = currentY > 50;
        updateNavSolid();

        if (currentY <= threshold) {
          header.classList.remove('cb-header--hidden');
        } else if (currentY > lastScrollY) {
          header.classList.add('cb-header--hidden');
        } else {
          header.classList.remove('cb-header--hidden');
        }

        lastScrollY = currentY;
        ticking = false;
      });
    });
  }

  // ===========================================================================
  // INIT + SHOPIFY EDITOR SUPPORT
  // ===========================================================================

  function init() {
    initNavigation();
    initScrollNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when section is reloaded in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cb-nav-wrapper')) {
      initNavigation._lastMode = null;
      init();
    }
  });
})();
